import NavBarWizardBaseCtrl from 'edge/platform/widgets/wizard/NavBarWizardBaseCtrl';

export default ['$scope', '$element', 'StateUtils', '$rootScope', '$state', function ($scope, $element, StateUtils, $rootScope, $state) {

    var baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
    var ctrl = Object.create(baseNavbarCtrl);

    ctrl.init = function () {
        $scope.headerMessageKey = '';
        $scope.isContextPageMenuOpen = false;
        $rootScope.$on('stickyHeaderExitViewport', ctrl.closeContextPageMenu);
        $scope.$on('updateHeaderMessageKey', function (event, messageKey) {
            $scope.updateHeaderMessageKey(messageKey);
        });

        StateUtils.beforeStateInit(ctrl._setQuoteSummaryData);
        StateUtils.afterStateInit(ctrl._checkIfSideMenuShouldBeClosed);
    };

    /* --- Context menu methods --- */
    ctrl.toggleContextPageMenu = function () {
        $scope.isContextPageMenuOpen = !$scope.isContextPageMenuOpen;
    };

    ctrl.closeContextPageMenu = function () {
        $scope.isContextPageMenuOpen = false;
    };

    /* --- Header message --- */
    $scope.updateHeaderMessageKey = function (messageKey) {
        $scope.headerMessageKey = messageKey;
    };

    $scope.shouldShowHeaderMessage = function () {
        return $state.$current.name === 'quickQuote' && angular.isDefined($scope.headerMessageKey);
    };

    /* --- Quote summary dropdown methods --- */
    ctrl._setQuoteSummaryData = function () {
        if (StateUtils.hasState('baseTransactionWizard')) {
            $scope.submission = StateUtils.dataForState('baseTransactionWizard').flowModel.snapshot.value;
        } else {
            $scope.submission = null;
        }
    };

    ctrl._isQuoteWizardVisible = function () {
        return StateUtils.hasState('baseTransactionWizard');
    };

    ctrl._checkIfSideMenuShouldBeClosed = function () {
        if (!ctrl._isQuoteWizardVisible() && ctrl.isSideBarMenuVisible()) {
            ctrl.hideSideBarMenu();
        }
    };

    return ctrl.create($scope);
}];


//////////////////
// WEBPACK FOOTER
// ./app/js/portal/directives/NavBarCtrl.js
// module id = 870
// module chunks = 0